import { FC } from "react";
import { connect } from "react-redux";
import { isNonNullExpression } from "typescript";
import { obtainData } from "../../../actions/subject";
import { normalizePredicate } from "../../../services/layout";
import { ApplicationState } from "../../../types";
import { I18NString } from "../../../types/modal";
import { isSubject, LayoutNode } from "../../../types/subject";
import { Bulb, BulbColorType } from "./bulb/Bulb";

interface BulbVariant {
  label: string;
  color: BulbColorType;
  value: number | null;
}

interface BulbIndicatorProps {
  subjectKey: string;
  nodeId: string;
  visible?: boolean;
  error?: string | I18NString;
  node?: LayoutNode;
  values?: {
    [K: string]: any;
  };
  value?: number;
}

const BulbIndicator: FC<BulbIndicatorProps> = ({
  node,
  visible,
  error,
  values,
}) => {
  const getNodeValue = () => {
    if (!node?.options || !values) {
      return null;
    }
    const { watchPredicate, path } = node.options;

    const predicate = normalizePredicate(watchPredicate);
    const predicateValue = values[predicate];

    if (typeof predicateValue !== "object") {
      return predicateValue;
    }
    if (!path) {
      return null;
    }
    try {
      console.log("bulb ====", watchPredicate, path, predicateValue, values);
      return obtainData(path, predicateValue);
    } catch (e) {
      console.log(
        `Error occured while getting value of predicate ${watchPredicate} by path ${path}`
      );
    }
    return null;
  };

  const getVariants = () => {
    let isOn = false;
    let color: BulbColorType = node?.options?.defaultColor || "secondary";
    const value = getNodeValue();

    const variants: BulbVariant[] | undefined = node?.options?.bulbVariants;
    if (!variants?.length || typeof value === "undefined" || value === null) {
      return { isOn, value: color };
    }
    const activeVariant = variants.find((v) => v.value == value);
    if (!activeVariant) {
      return { isOn, value: color };
    }
    const { value: bValue, color: bColor } = activeVariant;
    return {
      value: bColor,
      isOn: bValue == null ? false : true,
    };
  };
  const props = getVariants();
  if (!visible) {
    return null;
  }
  const size = node?.options?.size;
  return <Bulb {...props} size={size} />;
};

export default connect(
  (
    state: ApplicationState,
    ownProps: { subjectKey: string; nodeId: string }
  ) => {
    const { subjectKey, nodeId } = ownProps;
    const subject = state.subject && state.subject.subjects[subjectKey];

    if (!isSubject(subject)) {
      return { visible: false };
    }

    const serverLock = subject.subjectData.$lock;
    const serverLockReady = serverLock && serverLock.status;
    const isNew = subject.isNew;
    const cardEditable = serverLockReady || isNew;

    const node = subject.nodeById[nodeId];

    const error = subject.validation[nodeId];

    let valid = !error || !cardEditable ? true : false;

    const visible = subject.visibility[nodeId] ? true : false;

    return {
      error: error,
      node,
      values: subject.values,
      valid,
      visible,
      comment: subject.comment[nodeId],
    };
  },
  null
)(BulbIndicator);
